import { LaunchProofSummaryPanel } from "../../../LaunchProofSummaryPanel.js";
import type { ClientPortalApiClient } from "../../../api.js";

export function V10LaunchProofSection({
  api,
  linkId,
  token,
  enabled,
}: {
  readonly api: ClientPortalApiClient;
  readonly linkId: string;
  readonly token: string;
  readonly enabled: boolean;
}) {
  return <LaunchProofSummaryPanel api={api} clientLinkId={linkId} token={token} enabled={enabled} />;
}
